import React, { useState, useEffect } from 'react'
import { Panel, Row, Icon, Table, ButtonGroup, IconButton, Message } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { getDownloadFileCancel } from '../../redux/actions/cancelOfProject'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function CheckNoticeHistory({ data, header, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const [isFileError, setIsFileError] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      const file = await getDownloadFileCancel(projectId, fileObj.id, fileObj.fileType)
      const fileName = fileObj.name
      downloadFile(file, fileName)
      setIsFileError()
    } catch (e) {
      setIsFileError('ดาวน์โหลด')
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      const file = await getDownloadFileCancel(projectId, fileObj.id, fileObj.fileType)
      const fileName = fileObj.name
      previewFile(file, fileName)
      setIsFileError()
    } catch (e) {
      setIsFileError('แสดง')
    }
    doneLoading()
  }

  return (
    <>
      <Panel header={header} collapsible shaded defaultExpanded style={{ marginTop: 15 }}>
        {isFileError && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="error" description={`${isFileError}ไม่สำเร็จ`} />
          </Row>
        )}
        <Table
          autoHeight
          height={300}
          wordWrap
          bordered
          data={data ? [...data] : []}
          headerHeight={fs <= 15 ? undefined : fs < 16 ? 40 : fs <= 18 ? 45 : 50}
        >
          <Column width={70} align="center">
            <HeaderCell>ครั้งที่</HeaderCell>
            <Cell dataKey="seq" />
          </Column>

          <Column width={150}>
            <HeaderCell>ประเภท</HeaderCell>
            <Cell dataKey="type" />
          </Column>

          <Column width={150}>
            <HeaderCell>สถานะ</HeaderCell>
            <Cell dataKey="status" />
          </Column>

          <Column width={150}>
            <HeaderCell>วันที่เสนอ</HeaderCell>
            <Cell dataKey="requestDate" />
          </Column>

          <Column width={250}>
            <HeaderCell>ผู้เสนอ</HeaderCell>
            <Cell dataKey="requestBy" />
          </Column>

          <Column width={150}>
            <HeaderCell>วันที่พิจารณา</HeaderCell>
            <Cell dataKey="approveDate" />
          </Column>

          <Column width={250}>
            <HeaderCell>ผู้อนุมัติ</HeaderCell>
            <Cell dataKey="approverName" />
          </Column>

          <Column width={250}>
            <HeaderCell>ตำแหน่งผู้อนุมัติ</HeaderCell>
            <Cell dataKey="approverPosition" />
          </Column>
          <Column minWidth={350} width={350} flexGrow={1}>
            <HeaderCell>ความเห็นผู้อนุมัติ</HeaderCell>
            <Cell dataKey="approverReasons" />
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่ลงนาม</HeaderCell>
            <Cell dataKey="signedDate" />
          </Column>
          <Column width={160}>
            <HeaderCell>ดำเนินการล่าสุด</HeaderCell>
            <Cell dataKey="lastUpdateDate" />
          </Column>
          <Column width={160} align="center">
            <HeaderCell>หนังสือทวงถาม</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  rowData?.pathFile && (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={(e) => onPreview(rowData.pathFile)}
                      />
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => onDownload(rowData.pathFile)}
                      />
                    </ButtonGroup>
                  )
                )
              }}
            </Cell>
          </Column>
        </Table>
        <br />
      </Panel>
    </>
  )
}
